import { Form } from './form';
import { initiateMap, launchGeolocation, searchFieldLocation } from "../maps/index";

export class ChangeYMCAForm extends Form {

    constructor(form, container, view) {
        super(form);
        this.container = container;
        this.view = view;
        this.addFormBehavior();
    }

    addFormBehavior() {
        this.onSubmit();

        if (this.form.classList.contains('facility-form')) {
            initiateMap(0, 0);
            launchGeolocation();
            searchFieldLocation();
        }
    }

    onSubmit() {
        let self = this;

        this.submitButton.addEventListener('click', function(event) {
            let disabled = event.srcElement.classList.contains('disabled');
            if (!disabled) {
                // submit logic
                self.form.submit();
            }
        });
    }
}
